"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogService = exports.Logger = exports.LogStream = void 0;
/* tslint:disable:no-console */
var bblog_1 = require("bblog");
var index_1 = require("./index");
exports.LogStream = {
    LEVEL: bblog_1.Log.INFO,
    DELETE_KEYS: ['time', 'pid', 'msg', 'name', 'level', 'v', 'hostname'],
    setLevel: function (level) {
        exports.LogStream.LEVEL = level;
    },
    write: function (msg) {
        if (exports.LogStream.LEVEL > msg.level) {
            return;
        }
        var content = msg.msg;
        var output = {};
        Object.keys(msg).forEach(function (k) {
            if (exports.LogStream.DELETE_KEYS.indexOf(k) > -1) {
                return;
            }
            output[k] = msg[k];
        });
        if (Object.keys(output).length === 0) {
            output = '';
        }
        if (msg.level >= bblog_1.Log.WARN) {
            console.warn(content, output);
        }
        else if (msg.level >= bblog_1.Log.ERROR) {
            console.error(content, output);
        }
        else {
            console.log(content, output);
        }
    }
};
var logConfig = {
    name: 'DragonWeb',
    hostname: '?',
    streams: [exports.LogStream]
};
exports.Logger = bblog_1.Log.createLogger(logConfig);
var LogService = /** @class */ (function () {
    function LogService() {
        this.__priority = 5;
        this.Logger = exports.Logger;
    }
    LogService.prototype.init = function () {
        var window = index_1.Services.Window.window;
        var hostname = window.location.hostname;
        exports.Logger.addKeys({ hostname: hostname });
        if (hostname.indexOf('ikegps.com') > -1) {
            exports.LogStream.setLevel(bblog_1.Log.ERROR);
        }
    };
    return LogService;
}());
exports.LogService = LogService;
//# sourceMappingURL=log.service.js.map